module.exports = __webpack_public_path__ + "img/truck-pup.0b80f5ff.svg";